export const initPickup = function () {
  const pickupLink = document.querySelectorAll('[data-pickup-link]');


  if (pickupLink) {
    pickupLink.forEach((link) => {
      link.addEventListener('click', (evt) => {
        evt.preventDefault();
        const parent = link.closest('.order__address-inner');

        if (!parent.classList.contains('is-active')) {
          const pickUpBlock = document.querySelector('.order__address-inner.is-active');
          if (pickUpBlock) {
            pickUpBlock.classList.remove('is-active');
          }
          parent.classList.add('is-active');
        }

      })
    })
  }
}
